console.log('PUD three-way variant sync loaded');

(function () {
  const productHandle = 'personalised-name-panels-for-crochet-blankets';

  if (!window.location.pathname.includes('/products/' + productHandle)) {
    return;
  }

  let productDataPromise = null;
  let syncInProgress = false;

  function cleanImageUrl(url) {
    if (!url) return '';

    return url
      .split('?')[0]
      .replace(
        /_(\d+x\d+|pico|icon|thumb|small|compact|medium|large|grande|original)\./,
        '.'
      );
  }

  function imageFilename(url) {
    const cleanedUrl = cleanImageUrl(url);
    return cleanedUrl.split('/').pop() || '';
  }

  function loadProductData() {
    if (!productDataPromise) {
      productDataPromise = fetch(window.location.pathname + '.js')
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Could not load product JSON');
          }

          return response.json();
        })
        .catch(function (error) {
          console.log('Could not load product JSON', error);
          productDataPromise = null;
          return null;
        });
    }

    return productDataPromise;
  }

  function findMatchingVariant(productData, imageUrl) {
    if (!productData || !imageUrl) return null;

    const displayedFilename = imageFilename(imageUrl);

    if (!displayedFilename) return null;

    return productData.variants.find(function (variant) {
      if (!variant.featured_image || !variant.featured_image.src) {
        return false;
      }

      const variantFilename = imageFilename(
        variant.featured_image.src
      );

      return (
        displayedFilename === variantFilename ||
        displayedFilename.includes(variantFilename) ||
        variantFilename.includes(displayedFilename)
      );
    });
  }

  function updateDropdown(matchingVariant) {
    if (!matchingVariant || syncInProgress) return;

    const variantPicker = document.querySelector(
      'variant-selects, variant-radios'
    );

    if (!variantPicker) return;

    const selects = variantPicker.querySelectorAll('select');
    let requiresChange = false;

    selects.forEach(function (select, index) {
      const requiredValue = matchingVariant.options[index];

      if (
        requiredValue !== undefined &&
        select.value !== requiredValue
      ) {
        requiresChange = true;
      }
    });

    if (!requiresChange) return;

    syncInProgress = true;

    selects.forEach(function (select, index) {
      const requiredValue = matchingVariant.options[index];

      if (
        requiredValue !== undefined &&
        select.value !== requiredValue
      ) {
        select.value = requiredValue;
        select.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }
    });

    window.setTimeout(function () {
      syncInProgress = false;
    }, 300);

    console.log(
      'Dropdown updated to:',
      matchingVariant.title
    );
  }

  async function syncDropdownFromImage(imageUrl) {
    if (!imageUrl || syncInProgress) return;

    const productData = await loadProductData();
    if (!productData) return;

    const matchingVariant = findMatchingVariant(
      productData,
      imageUrl
    );

    if (!matchingVariant) {
      console.log(
        'No matching variant found for image:',
        imageUrl
      );
      return;
    }

    updateDropdown(matchingVariant);
  }

  /*
   * Thumbnail clicked:
   * thumbnail → main image → dropdown
   */
  document.addEventListener('click', function (event) {
    const thumbnailButton = event.target.closest(
      'button.thumbnail'
    );

    if (!thumbnailButton) return;

    const thumbnailImg =
      thumbnailButton.querySelector('img');

    if (!thumbnailImg) return;

    syncDropdownFromImage(
      thumbnailImg.currentSrc || thumbnailImg.src
    );
  });

/*
 * Main-image arrow or swipe changes Dawn's active thumbnail.
 * Watch that active thumbnail and synchronise the dropdown.
 */
function attachActiveThumbnailSync() {
  const thumbnailSliders = document.querySelectorAll(
    'slider-component.thumbnail-slider'
  );

  thumbnailSliders.forEach(function (thumbnailSlider) {
    if (thumbnailSlider.dataset.pudVariantObserver === 'true') {
      return;
    }

    thumbnailSlider.dataset.pudVariantObserver = 'true';

    let updateScheduled = false;

    async function updateFromActiveThumbnail() {
      updateScheduled = false;

      if (syncInProgress) return;

      const activeThumbnail = thumbnailSlider.querySelector(
        'button.thumbnail[aria-current="true"]'
      );

      if (!activeThumbnail) return;

      const thumbnailImage =
        activeThumbnail.querySelector('img');

      if (!thumbnailImage) return;

      const productData = await loadProductData();
      if (!productData) return;

      const imageUrl =
        thumbnailImage.currentSrc || thumbnailImage.src;

      const matchingVariant = findMatchingVariant(
        productData,
        imageUrl
      );

      if (matchingVariant) {
        updateDropdown(matchingVariant);
        return;
      }

      /*
       * The hero image is not assigned to a blanket variant.
       * If its first thumbnail becomes active, return the
       * dropdown to the first “Please select…” option.
       */
      const allThumbnails = Array.from(
        thumbnailSlider.querySelectorAll(
          'button.thumbnail'
        )
      );

      if (
        allThumbnails[0] === activeThumbnail &&
        productData.variants[0]
      ) {
        updateDropdown(productData.variants[0]);
      }
    }

    const observer = new MutationObserver(function (mutations) {
      const activeThumbnailChanged = mutations.some(
        function (mutation) {
          return (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'aria-current'
          );
        }
      );

      if (!activeThumbnailChanged || updateScheduled) return;

      updateScheduled = true;

      window.setTimeout(
        updateFromActiveThumbnail,
        50
      );
    });

    observer.observe(thumbnailSlider, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-current']
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    attachActiveThumbnailSync
  );
} else {
  attachActiveThumbnailSync();
}

  /*
   * Dropdown changed:
   * Shopify changes the main image and active thumbnail.
   * This ensures that the selected thumbnail remains visible.
   */
  document.addEventListener('variant:change', function () {
    const thumbnailSlider = document.querySelector(
      'slider-component.thumbnail-slider'
    );

    if (!thumbnailSlider) return;

    window.setTimeout(function () {
      const selectedThumbnail =
        thumbnailSlider.querySelector(
          '[aria-current="true"], .thumbnail[aria-current="true"]'
        );

      if (!selectedThumbnail) return;

      selectedThumbnail.scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
        inline: 'nearest'
      });
    }, 100);
  });
})();